<template>
    <div class="consultar-Produtos">
      <g-card
        class="card-consultas-produtos"
        margem="20px"
        :expansivel="true"
        :comecaFechado="false"
      >
        <template #cabecalho>
          <div class="header-filtros">
            <div class="titulo-filtros-cabecalho"> Produtos em Estoque </div>
            <div class="header-icons">
              <g-button
                class="trash-box"
                tipo="cinza"
                altura="35px"
                largura="45px"
                icone="icone_lixo.svg"
                tamanhoIcone="15px"
                somenteIcone
                :sombreado="false"
                v-tooltip="'Limpar filtro'"
                @click="limpar"
              />
              <g-button
                class="buscar-button-header-filtro"
                largura="150px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="Grid()"
              >
                BUSCAR
              </g-button>
            </div>
          </div>
        </template>

            <g-form>
                <div class="consultas-produtos-estoque-form espacamento-filtros">
                    <div class="empresa-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                            class="empresa-input unidade"
                            placeholder="TODAS"
                            :filter="true"
                            v-model="objFiltros.UnidadeId"
                            :options="EmpresaArray"
                            optionLabel="nome"
                            optionValue="id"
                        />
                    </div>


                    <!-- <div class="filial-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Filial </div>
                        <PDropDown
                            class="filial-input"
                            placeholder="Selecione"
                            v-model="objFiltros.FilialId"
                            :options="FilialArray"
                            optionLabel="nomeFilial"
                            optionValue="id"
                        />
                    </div> -->

                    <div class="nome-cliente-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Cliente </div>
                        <!-- <VMultiSelect
                            class="nome-cliente-input"
                            placeholder="Insira o nome do cliente"
                            :filter="true"
                            v-model="objFiltros.ClienteId"
                            @filter="buscarClientes($event.value)"
                            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                            :options="ClienteArray"
                            optionLabel="nomeFantasia"
                            optionValue="id"
                        >
                            <template #option="slotProps">
                                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                            </template>
                        </VMultiSelect> -->
                        <cliente-dropdown
                            class="p-dropdown cliente"
                            @change="ativaClienteAgrupador"
                            v-model="objFiltros.ClienteId"
                            :empresaId="objFiltros.UnidadeId"
                            :representanteId="this.$store.state.representanteSelecionadoId"
                        />
                    </div>

                    <div class="nome-produto label">
                        <div class="codigo-produto-titulo titulo-conteudo-filtros"> Nome do Produto </div>
                        <PDropDown
                        class="nome-produto-input input-label"
                        v-model="objFiltros.NomeProduto"
                        placeholder="Insira o nome do produto"
                        optionLabel="labelProduto"
                        optionValue="produtoId"
                        @filter="getProduto($event.value)"
                        :filter="true"
                        :options="ProdutoArray"
                        />
                    </div>

                    <div class="ordenacao-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Ordenação </div>
                        <PDropDown
                            class="codigo-ordenacao-input"
                            placeholder="Código"
                        />
                    </div>

                    <div class="descricao-produto-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Segmento </div>
                        <PDropDown
                            class="segmento-input"
                            :filter="true"
                            placeholder="Selecione"
                            optionLabel="text"
                            optionValue="value"
                            v-model="objFiltros.SegmentoProdutoEstoque"
                            :options="SegmentoProdutoEstoqueArray"
                        />
                    </div>

                    <div class="dias-estoque-produtos-estoque label">
                        <div class="titulo-conteudo-filtros-datas"> Dias em Estoque </div>
                        <div class="dias-input-text">
                            <PInputText
                                class="dias-input"
                                placeholder="N° Dias"
                                v-model="objFiltros.DiasEstoqueMin"

                            />
                            <div class="titulo-conteudo-filtros-datas"> à </div>
                            <PInputText
                                class="dias-input"
                                placeholder="N° Dias"
                                v-model="objFiltros.DiasEstoqueMax"
                            />
                        </div>
                    </div>

                    <div class="tipo-produtos-estoque tipo-status-label tipo-status">
                        <div class="titulo-conteudo-filtros"> Tipo </div>
                        <PDropDown
                            class="tipo-input"
                            :filter="true"
                            placeholder="Selecione"
                            optionLabel="text"
                            optionValue="value"
                            v-model="objFiltros.TipoProdutoEstoque"
                            :options="TipoProdutoEstoqueArray"
                        />
                    </div>

                    <div class="status-produtos-estoque tipo-status-label tipo-status">
                        <div class="titulo-conteudo-filtros"> Status </div>
                        <PDropDown
                            class="status-input"
                            :filter="true"
                            placeholder="Selecione"
                            optionLabel="text"
                            optionValue="value"
                            v-model="objFiltros.Status"
                            :options="StatusArray"
                        />
                    </div>

                    <div class="segmento-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Outros Parâmetros </div>
                        <div class="consultar-dados">
                            <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados" class="checkbox-consultas" v-model="objFiltros.ConsultarDadosClienteAgrupador"></PCheckBox>
                            <label class="label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                        </div>
                    </div>

                    <div class="parametros-produtos-estoque label">

                    </div>
                </div>
            </g-form>
            <div class="buscar-button-filtro">
            <g-button
                class="buscar-button"
                icone="icone_lupa.svg"
                negritoTexto
                largura="100%"
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="Grid()"
            >
                BUSCAR
            </g-button>
        </div>

        </g-card>
        <g-card
        margem="20px"
        paddingDefault="0 0em 1em"
        :expansivel="false"
        :temCabecalho="false"
        class="card-resultado"
      >
        <div v-if="pt1" class="">
          <img
            class="icone-global-imagemfundo"
            src="@/assets/imgs/Ilustracao_erro.svg"
          />
          <div class="texto-padrao-imagemfundo">
            Verifique os filtros e clique em buscar para exibir os resultados
          </div>
        </div>

        <div v-else-if="!pt1">
          <g-data-table
          Titulo="Produtos em Estoque"
          altura="auto"
          :colunas="Colunas"
          :NumeroLinhas="100"
          :Filtros="Filtro"
          :FiltrosEspecificos = "true"
          :Editavel= "false"
          :checkprancheta = "false"
          :Paginacao="true"
          :Expansivel="true"
          v-model:expandedRowGroups="ProdutosEstoqueArray"
          :valores="ProdutosEstoqueArray"
          EscondeColunaBotao
          v-on:duploClickLinha="detalhesProdutoEstoque"
          :campoAgrupador="'empresaCliente'"
          :campoExibicaoGrupo="'empresaCliente'"
          :telaProdutosEstoque="true"
        >
        <template #groupfooter="slotProps"> 
            <g-data-table
                :valores="[{}]"
                :ehSemDados="false"
                :ehReordenavel="false"
                :Paginacao = false
                :colunas="[
                        {header: 'Total : ', width: '350px'},
                        {header: ''},
                        {header: slotProps.soma.valorFinalSomaCaixas.toLocaleString('pt-BR'), alinha: 'right'},
                        {header: slotProps.soma.valorFinalSomaFolhas.toLocaleString('pt-BR'), alinha: 'right'},
                        {header: slotProps.soma.valorFinalSomaValorTotal, alinha: 'right'},
                        {header: ''},
                        {header: ''},
                ]"
                :esconderHeader="true"
                :esconderColunaFrozen="true"
                :Expansivel="true"
            >
            </g-data-table>
        </template> 
    </g-data-table>
        </div>
      </g-card>
    </div>
  </template>

<script>
import ProdutosEstoque from './ProdutosEstoque.js'
export default ProdutosEstoque
</script>

<style scoped>
    .consultas-produtos-estoque-form {
        width: 95%;
        text-align: left;
        display: flex;
        margin: 0 auto;
        margin-top: 3px;
        flex-direction: column;
        align-items: center;
    }

    .codigo-produto-input {
        width: 100%;
        display: flex;
        justify-content: flex-start;
    }

    .dias-input-text {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .dias-input {
        width: 45%;
        text-align: center;
    }

    .label-checkbox {
        font-size: 14px;
        font-family: "Montserrat";
        color: #8A8A8A;
        margin-left: 2%;
    }

    .consultar-dados {
        display: flex;
    }

    .titulo-conteudo-filtros-datas{
    text-align: center;
    font-size: 15px;
    font-family: "MontSerrat";
    font-weight: bold;
    margin: 10px 0 2px;
    }

    @media (min-width:310px) {
        .unidade { order: 1 }
        .consultas-produtos-estoque-form {
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: repeat(9, 115px), 120px;
        }

        .codigo-nome-produto {
        display: grid;
        grid-template-columns: 30% auto;
        grid-area: 4 / 1 / 4 / 3;
        grid-template-rows: auto;
        grid-column-gap: 20px;
        align-items: flex-end;
        }

        .label, .tipo-status {
            text-align: left;
        }

        .empresa-produtos-estoque { grid-area: 1 / 1 / 2 / 3; }
        .nome-cliente-produtos-estoque { grid-area: 2 / 1 / 3 / 3; }
        .filial-produtos-estoque {  grid-area: 3 / 1 / 4 / 3; }
        .ordenacao-produtos-estoque { grid-area: 5 / 3 / 5 / 1 ;}
        .descricao-produto-produtos-estoque { grid-area: 6 / 1 / 7 / 3; }
        .dias-estoque-produtos-estoque { grid-area: 7 / 1 / 8 / 3; }
        .tipo-produtos-estoque { grid-area: 8 / 1 / 9 / 3; }
        .status-produtos-estoque { grid-area: 9 / 1 / 9 / 3; }
        .segmento-produtos-estoque { grid-area: 10 / 1 / 10 / 3; }
        .parametros-produtos-estoque { grid-area: 11 / 1 / 11 / 3; }
    }


    @media (min-width:368px) {}

    @media (min-width:600px) {}

    @media (min-width:801px) {}


    @media (min-width:1025px) {
        .consultas-produtos-estoque-form {
            display: grid;
            grid-template-columns: repeat(5, auto);
            grid-column-gap: 20px;
            grid-row-gap: 10px;
            width: 98%;
        }

        .codigo-nome-produto { grid-area: 1 / 6 / 1 / 4; align-self: normal;}

        .tipo-status {
            align-self: flex-end;
        }

        .empresa-produtos-estoque { grid-area: 1 / 1 / 2 / 2; }
        .nome-cliente-produtos-estoque { grid-area: 1 / 2 / 2 / 4; }
        .filial-produtos-estoque { grid-area: 1 / 4 / 2 / 5; }
        .descricao-produto-produtos-estoque { grid-area:1 / 5 / 2 / 7; }
        .dias-estoque-produtos-estoque { grid-area: 2 / 1 / 3 / 2; }
        .tipo-produtos-estoque { grid-area: 2 / 2 / 3 / 3; width: 100%}
        .status-produtos-estoque { grid-area: 2 / 3 / 3 / 4; width: 100%}
        .segmento-produtos-estoque { grid-area: 2 / 4 / 3 / 5; }
        .parametros-produtos-estoque { grid-area: 2 / 5 / 3 / 7; margin-left: 10px;}
        .ordenacao-produtos-estoque {display: none;}
    }


    @media (min-width:1281px) {
        .ordenacao-produtos-estoque {display: none;}
        .codigo-nome-produto { grid-area: 1 / 6 / 1 / 4; align-self: normal;}
    }

</style>